// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TMyHomeObjectsExistsModel,
  IMappers,
  TMyHomeObjectsExistsResponse,
  IMyHomeObjectsExistsResponse,
  IMyHomeObjectsExistsResponseError,
} from './types';

export const defaultConfig: TMyHomeObjectsExistsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v1/my-home-objects-exists/',
} as TMyHomeObjectsExistsModel;

export function createMyHomeObjectsExistsModel(): TMyHomeObjectsExistsModel {
  return {
    ...defaultConfig,
  };
}

export interface IMyHomeObjectsExistsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchMyHomeObjectsExists<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IMyHomeObjectsExistsOptions<TResponse200, TResponse400>): Promise<
  TMyHomeObjectsExistsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createMyHomeObjectsExistsModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMyHomeObjectsExistsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IMyHomeObjectsExistsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TMyHomeObjectsExistsResponse;
}
